var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121619",
    d: "m22.03 20.469-4.693-4.694a8.26 8.26 0 1 0-1.06 1.06l4.692 4.695a.752.752 0 0 0 1.224-.244.75.75 0 0 0-.162-.817m-17.78-9.97A6.75 6.75 0 1 1 11 17.25a6.757 6.757 0 0 1-6.75-6.75"
  })));
};
export default SvgSearchIcon;